import Icon from 'antd/lib/icon'
import styled from 'styled-components'

interface DivProps {
  width?: string
  verticalAlign?: string
  backgroundColor?: string
  extraCss?: string
  secondary?: boolean
  fullHeight?: boolean
}

export const Container = styled.div`
  width: ${({ width }: DivProps) => width ? width : '100%'};
  text-align: center;
  height: ${({ fullHeight }: DivProps) => fullHeight ? '100%' : 'auto'};
  background: ${({ backgroundColor }: DivProps) => backgroundColor || 'unset'};
  ${({ verticalAlign }: DivProps) => verticalAlign ? `
    display: flex;
    align-items: ${verticalAlign};
  ` : ''}
  ${({ extraCss }: DivProps) => extraCss ? 
    extraCss
  : ''}
`

export const ImagePreview = styled.img`
  object-fit: cover;
  width: 100%;
  cursor: pointer;
`

export const VideoPreview = styled.video`
  object-fit: cover;
  margin-bottom: -3px;
  width: 100%;
  height: 100%;
`

export const IframeComponent = styled.iframe`
  width: 100%;
  height: 100%;
`

export const ProductContainer = styled.div`
  position: relative;
  overflow: hidden;
  font-family: Avenir;
  &:hover {
    .hoverImage { display: block; }
    .infoProduct, .hoverControls { display: flex; }
  }
  @media (min-width: 768px) {
    .mediaDiv:hover {
      cursor: pointer;
    }
  }
`

export const ImageHover = styled.img`
  position: absolute;
  display: none;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: fade-in-hover 0.325s cubic-bezier(0, 0, 0.58, 1.0) both;
  @keyframes fade-in-hover {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    75% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: scale(1.15);
    }
  }
`

export const Info = styled.div`
  position: absolute;
  padding: 12px 20px 10px 20px;
  left: 0px;
  width: 100%;
  justify-content: space-between;
  bottom: 0;
  display: flex;
  z-index: 3;
  align-items: center;
  @media (max-width: 698px) {
    position: inherit;
    padding-top: 10px;
    z-index: 2;
    background: white;
    line-height: 1;
  }
`

export const LabelDiv = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  line-height: 1.25;
  text-align: left;
`

export const CustomIcon = styled.img`
  width: 18px;
  margin-top: -4px;
  margin-right: 10px;
`

export const ProductName = styled.div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
`

export const LearnMore = styled.div`
  border: 1px solid black;
  padding: 4px 10px;
  color: black;
  transition: background .25s;
  &:hover {
    cursor: pointer;
    background: white;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const Hyperlink = styled(Icon)`
  display: none;
  @media (max-width: 698px) {
    display: block;
    transform: scaleX(-1);
    color: cornflowerblue;
    font-size: 18px;
    margin-right: -6px;
  }
`

export const ProductInfo = styled.div`
  position: absolute;
  display: none;
  bottom: 100px;
  justify-content: space-between;
  background: #00000066;
  width: 100%;
  padding: 8px 18px;
  color: white;
  text-align: left;
  z-index: 3;
  animation: fade-in-info 0.25s cubic-bezier(0, 0, 0.58, 1.0) both;
  @keyframes fade-in-info {
    0% {
      opacity: 0;
      transform: translateY(14px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @media (max-width: 698px) {
    padding: 8px;
    #firstSizeR {
      margin-right: 6px;
    }
  }
`

export const SizeRangeLabel = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  font-size: 10px;
`

export const VideoControls = styled.div`
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: #00000030;
`

export const PlayPause = styled(Icon)`
  font-size: 36px;
  margin-right: 20px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    font-size: 37px;
    opacity: 0.8;
  }
`

export const MuteButton = styled(Icon)`
  font-size: 28px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    font-size: 29px;
    opacity: 0.8;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CarouselItem/styledComponents.tsx